// extracted by mini-css-extract-plugin
export default {"print-container":"_3qxly","printContainer":"_3qxly"};